import clsx from 'clsx'
import React, { ButtonHTMLAttributes } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant: 'green' | 'red' | 'blue' | 'link'
  isFullWidth?: boolean
  children: React.ReactNode
}
export const Button = ({
  children,
  variant,
  className,
  isFullWidth,
  ...buttonAttrs
}: ButtonProps) => {
  return (
    <button
      className={clsx('rounded p-2 text-sm uppercase', className, {
        'bg-brightGreen hover:bg-brightGreen/75 text-white':
          variant === 'green',
        'bg-red-500 text-white hover:bg-red-700': variant === 'red',
        'bg-trueBlue hover:bg-trueBlue/75 text-white': variant === 'blue',
        'text-trueBlue hover:text-trueBlue/75 hover:underline':
          variant === 'link',
        'w-100': isFullWidth,
      })}
      {...buttonAttrs}
    >
      {children}
    </button>
  )
}
